import * as React from "react";
import { cn } from "@/lib/utils";
import { ChevronDown } from "lucide-react";

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  wrapperClassName?: string;
}

function Select({ className, wrapperClassName, children, ref, ...props }: SelectProps & { ref?: React.Ref<HTMLSelectElement> }) {
  return (
    <div className={cn("relative inline-flex", wrapperClassName)}>
      <select
        className={cn(
          "h-9 w-full appearance-none rounded-xl border border-input bg-[hsl(var(--input))] pl-3 pr-8 py-1 text-sm shadow-sm transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:shadow-md disabled:cursor-not-allowed disabled:opacity-50",
          className
        )}
        ref={ref}
        {...props}
      >
        {children}
      </select>
      <ChevronDown className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 h-3.5 w-3.5 text-muted-foreground" />
    </div>
  );
}

export { Select };
